// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__1i_lw","spinner__selector":"styles_spinner__selector__1cLr0"};